export const invertedMessages = {
  "Couldn't Load": 'COULD_NOT_LOAD.ATTESTATIONS',
  Refresh: 'Refresh.ATTESTATIONS',
  Close: 'CloseLabel',
  "The Summary tab didn't load properly due to a network issue. Please refresh or try again later.":
    'CERTS_SIDEPANEL_TAB_SUMMARY',
  "The History tab didn't load properly due to a network issue. Please refresh or try again later.":
    'CERTS_SIDEPANEL_TAB_HISTORY',
  "The Progress tab didn't load properly due to a network issue. Please refresh or try again later.":
    'CERTS_SIDEPANEL_TAB_PROGRESS',
  Cancelled: 'CancelledCertification.Default.label',
  Completed: 'Completed.Certification.label',
  Reassigned: 'Reassigned.v2.label.ATTESTATIONS',
  Exported: 'Exported.Certification.label',
};
